export enum ModalNames {
  SETTINGS = 'settings'
}
